import dsdInstance from "./dsdInstance";

const getAICases = () => {
    return dsdInstance.get("/ai-simulation-service/getItemcount");
  };

export default {
    getAICases: getAICases
};
